import React from 'react'
// import Partners from './Partners.jsx'
// import Examples from './Examples.jsx'
import {
  Button,
  Container,
  // Divider,
  // Grid,
  Header,
  Icon,
  // Image,
  // List,
  // Menu,
  // Responsive,
  // Segment,
  // Sidebar,
  // Visibility,
} from 'semantic-ui-react'


// const Head = () => (
//   <Container text >
//     <Header
//       as='h1'
//       content='DIGITAL AGENCY'
//       inverted
//       style={{ fontSize: '4.8em', fontWeight: 500, marginBottom: 0, marginTop: '3em', textTransform:'uppercase' }}
//     />
//     <Header
//       as='h2'
//       content='Web, mobile apps and much more…'
//       inverted
//       style={{ fontSize: '1.7em', fontWeight: 300 }}
//     />
//     <br /><br />
//     <a href='#contacts'>
//       <Button primary size='huge'>
//         Start Project
//         <Icon name='right arrow' />
//       </Button>
//     </a>
//   </Container>
// )


const HomepageHeading = ({ mobile }) => (
  <Container text>
    <Header
      as='h1'
      content='DIGITAL AGENCY'
      inverted
      style={{
        fontSize: mobile ? '2em' : '4em',
        fontWeight: 'normal',
        marginBottom: 0,
        marginTop: mobile ? '1.5em' : '3em',
      }}
    />
    <Header
      as='h2'
      content='Web, mobile apps and much more…'
      inverted
      style={{
        fontSize: mobile ? '1.5em' : '1.7em',
        fontWeight: 'normal',
        marginTop: mobile ? '0.5em' : '1.5em',
      }}
    />
    <a href='#contacts'>
      <Button primary size='huge'>
        Start Project
        <Icon name='right arrow' />
      </Button>
    </a>
  </Container>
)

export default HomepageHeading



// WEBPACK FOOTER //
// ./src/components/Head.jsx